import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

import { DialogHost } from '@/components/feedback/dialog';

import { PageContainer } from '../page-container';
import { Sidebar } from '../sidebar';
import { Topbar } from '../topbar';

import styles from './app-shell.module.scss';

const { Content } = Layout;

export function AppShell() {
  return (
    <DialogHost>
      <Layout className={styles.shell}>
        <Sidebar />
        <Layout>
          <Topbar />
          <Content className={styles.content}>
            <PageContainer>
              <Outlet />
            </PageContainer>
          </Content>
        </Layout>
      </Layout>
    </DialogHost>
  );
}
